import React from 'react';
import { Card } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import MarkdownContent from '../../../../../../components/MarkdownContent/MarkdownContent';
import './Description.css';
export default function Description(_ref) {
  var description = _ref.description;
  if (_isEmpty(description)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Card.Description, {
    className: "information"
  }, /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "markdown",
    content: description
  }));
}